import { EMAIL_MESSAGE_STATUSES, PaymentMethods } from '../../../../../../services/exports/Constants';
import TemplateNames from '../email-messages/TemplateNames';

export default {
  page_title: 'Follower',
  fields: {
    name: 'Nome:',
    email: 'Email:',
    phone_number: 'Telefono:',
    subscribed: 'Iscritto:',
    birthday: 'Compleanno:',
    location: 'Posizione:',
    followed: 'Seguito:',
    lifetime_spent: 'Spesa totale:',
    total_orders: 'Ordini totali:',
    google_review: 'Recensione Google:',
    loyalty_lifetime: 'Fedeltà complessiva:',
    loyalty_points: 'Fedeltà oggi:',
  },
  labels: {
    yes: 'Sì',
    no: 'No',
    followed_since_date: 'Dal {{date}}',
  },
  buttons: {
    edit: 'Modifica',
    request_data_deletion: 'Richiedi eliminazione dati',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
  },
  tabs: {
    recent_orders: {
      title: 'Ordini recenti',
      columns: {
        order_id: 'Id',
        items: 'Articoli',
        total: 'Importo totale',
        paid_on: 'Pagato il',
        payment_method: 'Metodo di pagamento',
      },
      labels: {
        no_orders: 'Nessun ordine ancora',
      },
      payment_methods: {
        [PaymentMethods.CARD]: 'Carta',
        [PaymentMethods.PAYPAL]: 'PayPal',
        [PaymentMethods.APPLE_PAY]: 'Apple Pay',
        [PaymentMethods.GOOGLE_PAY]: 'Google Pay',
        [PaymentMethods.LINK]: 'Link',
        [PaymentMethods.SOFORT]: 'Sofort',
        [PaymentMethods.IDEAL]: 'iDEAL | Wero',
        [PaymentMethods.BANCONTACT]: 'Bancontact',
        [PaymentMethods.EPS]: 'EPS',
        [PaymentMethods.P24]: 'Przelewy24',
        [PaymentMethods.BLIK]: 'BLIK',
        [PaymentMethods.TWINT]: 'TWINT',
        [PaymentMethods.VENMO]: 'Venmo',
        [PaymentMethods.WERO]: 'Wero',
        [PaymentMethods.KLARNA]: 'Klarna',
        [PaymentMethods.TRUSTLY]: 'Trustly',
        [PaymentMethods.PIX]: 'Pix',
        [PaymentMethods.NUPAY]: 'NuPay',
        [PaymentMethods.GIROPAY]: 'Giropay',
        [PaymentMethods.SEPA_DEBIT]: 'Addebito bancario',
        [PaymentMethods.CASH]: 'Contanti',
        [PaymentMethods.BACS_DEBIT]: 'Addebito bancario',
      },
    },
    messages: {
      title: 'Messaggi',
      columns: {
        template: 'Modello',
        status: 'Stato',
        opened: 'Aperto',
        clicked: 'Cliccato',
        spam_complaint: 'Segnalazione spam',
        unsubscribed: 'Disiscritto',
        sent_at: 'Inviato il',
      },
      labels: {
        yes: 'Sì',
        no: 'No',
        not_detected: 'Non rilevato',
        opened_at: 'Aperto il {{date}}',
        clicked_at: 'Cliccato il {{date}}',
        complained_at: 'Segnalato il {{date}}',
        unsubscribed_at: 'Disiscritto il {{date}}',
        no_messages: 'Nessun messaggio',
      },
      message_statuses: {
        [EMAIL_MESSAGE_STATUSES.SENT]: 'Inviato',
        [EMAIL_MESSAGE_STATUSES.DELIVERED]: 'Consegnato',
        [EMAIL_MESSAGE_STATUSES.FAILED]: 'Fallito',
      },
      template_names: {
        ...TemplateNames,
      },
      toasts: {
        failed_to_load_data: 'Caricamento dati non riuscito',
      },
    },
    balance_history: {
      title: 'Storico saldo',
      columns: {
        created_at: 'Data',
        source: 'Fonte',
        value: 'Punti',
        points_expire_at: 'Scade il',
      },
      labels: {
        source: {
          welcome_bonus: 'Bonus di benvenuto',
          google_review_reward: 'Premio recensione Google',
          reward_loyalty_program_conversion: 'Premio conversione programma fedeltà',
          cashback: 'Cashback',
          refund: 'Rimborso',
          cashback_usage: 'Utilizzo cashback',
          cashback_usage_refund: 'Rimborso utilizzo cashback',
          expired_points_void: 'Annullamento punti scaduti',
          mobile_app_signup_bonus: 'Bonus iscrizione app mobile',
        },
        no_operations: 'Nessuna operazione',
      },
    },
  },
};
